import React, { useContext, useEffect } from 'react'

import { CompletedCartsContext } from '../../../lib/completed-carts/context'
import { usePageUrl } from '../../../lib/pages'
import Spinner from '../../Spinner'

const MostRecentConfirmation: React.FC = () => {
  const completedCarts = useContext(CompletedCartsContext)
  const mostRecent = completedCarts.mostRecent()
  const { navigate } = usePageUrl()

  useEffect(() => {
    if (!mostRecent) {
      navigate('/checkout')
      return
    }
    navigate(`/checkout/confirmation/${mostRecent.completedAt}`)
  }, [mostRecent, navigate])

  return <Spinner loading />
}

export default MostRecentConfirmation
